import { createFetch } from '@vueuse/core'
import { defineStore } from 'pinia'

import i18n from '@/libs/i18n'
import { PrintError } from '@/libs/toast'
import router from '@/router'
import { useAppStore } from '@/stores/app'

export const useFetchStore = defineStore('fetch', () => {
    const appStore = useAppStore()

    const fetch = createFetch({
        // The reception portal's own base. One service, two windows.
        baseUrl: '/api/pms/v1',
        options: {
            /**
             * KEEP THE BODY OF A FAILED CALL.
             *
             * VueUse throws it away by default, and every read in this console goes
             * through `libs/loadState.ts`, which shows the SERVICE's own sentence —
             * „modul ni vključen“, „objekt je izven obsega“. Without this they all
             * print the generic fallback, and a screen that says "could not load"
             * where the server said "you may not see this house" is a screen that
             * sends somebody looking for a fault that is not there.
             */
            updateDataOnError: true,

            beforeFetch({ options }) {
                options.headers = new Headers(options.headers)
                options.headers.set('Authorization', `Bearer ${appStore.getJWT()}`)

                return { options }
            },

            async onFetchError(ctx) {
                // A refused sign-in is not an expired session: the sign-in screen says
                // "wrong username or password" itself, and a second message about a
                // session that ran out sends somebody who mistyped a password looking
                // for a fault that is not there.
                if (ctx.response?.status === 401 && appStore.isLoggedIn()) {
                    PrintError(i18n.global.t('errors.session_expired'))

                    appStore.setLogout()
                    await router.push({ name: 'login' })
                }

                return ctx
            },
        },
    })

    return { fetch }
})
